import { Box, Stack, TextField } from '@mui/material';
import { format } from 'date-fns';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DATE_FORMAT_API } from '../../../../../../../../@constants/date';
import DatePicker from '../../../../../../../../components/DatePicker/DatePicker';
import { FileExcelIcon } from '../../../../../../../../components/SvgIcons/FileExcelIcon';
import { FilePdfIcon } from '../../../../../../../../components/SvgIcons/FilePdfIcon';
import { FooterExtraButtons } from '../../../../../../components/FooterButtons';
import { RoomTypeField } from '../../../../../../components/Inputs/RoomTypeField';
import { ReportLabel } from '../../../../../../components/ReportLabel';
import { RoomStateReportFormModel } from '../../models';
import { OccupancyField } from './fields/OccupancyField';
import { StateField } from './fields/StateField';

export const FilterForm: FC<{
  onSubmit: (data: RoomStateReportFormModel) => void;
  onReset: () => void;
}> = ({ onSubmit, onReset }) => {
  const { control, handleSubmit, setValue } = useFormContext<RoomStateReportFormModel>();

  return (
    <Box sx={{ p: 0, height: '100%', backgroundColor: 'colors.gray.o10', overflowY: 'scroll' }}>
      <Stack direction={'column'} spacing={0} sx={{ width: '100%', height: '100%' }}>
        <ReportLabel label="Room State" />
        <Stack direction={'column'} spacing={2} p={3}>
          <Controller
            control={control}
            name="date"
            render={({ field, fieldState: { error } }) => (
              <DatePicker
                name="day"
                label="Day"
                value={field.value}
                onChange={(value: string) =>
                  field.onChange(format(new Date(value), DATE_FORMAT_API))
                }
                error={Boolean(error)}
                helperText={error}
                renderInput={(params: any) => <TextField variant="standard" {...params} />}
              />
            )}
          />

          <Controller
            control={control}
            name="room_type_ids"
            render={({ field, fieldState, formState }) => (
              <RoomTypeField value={field.value} onChange={value => field.onChange(value)} />
            )}
          />

          <Controller
            control={control}
            name="room_state"
            render={({ field, fieldState, formState }) => (
              <StateField value={field.value} onChange={value => field.onChange(value)} />
            )}
          />

          <Controller
            control={control}
            name="occupancies_type"
            render={({ field, fieldState, formState }) => (
              <OccupancyField value={field.value} onChange={value => field.onChange(value)} />
            )}
          />

          <Box sx={{ height: 48, display: 'flex', alignItems: 'center', mt: 1 }}></Box>
        </Stack>
        <FooterExtraButtons
          onSubmit={file_type => {
            setValue('file_type', file_type);
            handleSubmit(onSubmit)();
          }}
          onReset={onReset}
          exportFileTypes={[
            {
              label: 'PDF',
              value: 'pdf',
              icon: <FilePdfIcon sx={{ width: '3rem', height: '3rem' }} />,
            },
            {
              label: 'EXCEL',
              value: 'excel',
              icon: <FileExcelIcon sx={{ width: '3rem', height: '3rem' }} />,
            },
          ]}
        />
      </Stack>
    </Box>
  );
};
